module.exports = __webpack_public_path__ + "img/photo-28.5c86782c.jpg";